import script from "./BrightcoveVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrightcoveVideo.vue?vue&type=script&setup=true&lang=ts"

import "./BrightcoveVideo.vue?vue&type=style&index=0&id=0e12d025&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e12d025"]])

export default __exports__